import React, { useEffect, useState } from "react";
import Header3 from "../Header3/Header3";

interface Navbar3Props {
  hclass?: string;
}

const Navbar3: React.FC<Navbar3Props> = ({ hclass }) => {
  const [scroll, setScroll] = useState<number>(0);

  useEffect(() => {
    const handleScroll = () => setScroll(document.documentElement.scrollTop);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const className = scroll > 80 ? "fixed-navbar active" : "fixed-navbar";

  return (
    <div className={className}>
      <Header3 hclass={hclass} />
    </div>
  );
};

export default Navbar3;
